import en from './en';

const fr = {
  ...en,
  lang: 'fr',
  langName: 'Français',
  flag: '🇫🇷',
  siteTitle: 'Tests TOEFL iBT gratuits - Analyse IA | Power TOEFL 2026',
  siteDescription: 'Entraînez-vous gratuitement avec les derniers tests TOEFL 2026 et profitez d’une analyse IA pour Reading, Listening, Speaking et Writing.',
  ogTitle: 'Tests TOEFL iBT gratuits - Analyse IA | Power TOEFL 2026',

  navGrammar: 'Grammaire',
  navPractice: 'Pratique par section',
  navScoreChart: 'Barème des scores',
  navVocabulary: 'Vocabulaire',
  navTips: 'Conseils et stratégie',
  navFAQ: 'FAQ',
  navReading: 'Reading',
  navListening: 'Listening',
  navSpeaking: 'Speaking',
  navWriting: 'Writing',
  navQuestionPool: 'Banque de questions',
  navResources: 'Ressources',
  navPremium: 'Offre Premium',

  loginButton: 'Se connecter',
  wrongAnswers: 'Carnet d’erreurs',
  logout: 'Se déconnecter',
  loginRequired: 'La connexion est requise pour le carnet d’erreurs et la reprise.',

  heroBadge: 'Système TOEFL Premium',
  moreTools: 'Plus d’outils d’apprentissage',
  practiceLabel: 'Pratique par section',
  practiceDesc: 'Travaillez Reading et Listening séparément',
  scoreChartLabel: 'Conversion des scores',
  scoreChartDesc: 'Réponses correctes vers score estimé',
  vocabLabel: 'Vocabulaire',
  vocabDesc: 'Vocabulaire essentiel du TOEFL',
  tipsLabel: 'Conseils et stratégie',
  tipsDesc: 'Plan pour Reading et Listening',
  catLabel: 'Test adaptatif CAT',
  catDesc: 'La difficulté s’adapte automatiquement',
  guideLabel: 'Guides d’étude',
  guideDesc: 'Stratégies par compétence et par score',
  grammarSectionTitle: 'Livre de grammaire anglaise',
  grammarSectionDesc: 'Renforcez vos bases pas à pas',
  grammarViewAll: 'Voir tout',

  footerMockTest: 'Pratique',
  footerQuestionPool: 'Banque de questions',
  footerPractice: 'Pratique par section',
  footerStudy: 'Étude',
  footerBooks: 'Livres recommandés',
  footerEtc: 'Plus',
  footerLC: 'Pratique Listening',
  footerRC: 'Pratique Reading',
  footerSpeaking: 'Pratique Speaking',
  footerWriting: 'Pratique Writing',
  footerLCStrategy: 'Stratégie Listening',
  footerRCStrategy: 'Stratégie Reading',
  footerGuide: 'Guide d’étude',
  footerPrivacy: 'Politique de confidentialité',
  footerTerms: 'Conditions d’utilisation',
  footerRefund: 'Politique de remboursement',
  footerAbout: 'À propos',
  footerCopyright: '© 2026 Power TOEFL. Tous droits réservés.',
  footerDisclaimer: 'TOEFL® est une marque déposée d’ETS. Power TOEFL est une plateforme indépendante non affiliée à ETS.',

  heroTitle1: 'Une seule plateforme',
  heroTitle2: 'pour améliorer votre score TOEFL',
  heroDesc1: 'Des tests blancs réalistes à l’analyse des erreurs,',
  heroDesc2: 'tout ce qu’il faut au même endroit.',
  fullTestCardLabel: 'Test complet',
  fullTestCardDesc: 'Simulation réaliste de Reading et Listening',
  proBadgeLabel: 'Pro',
  googleLogin: 'Commencer avec Google',

  pwaAddToHome: 'Ajouter à l’écran d’accueil',
  pwaAddToHomeDesc: 'Ouvrez Power TOEFL plus vite comme une application.',
  pwaInstall: 'Installer',
  pwaIOSGuide: 'Partager',

  resumeTest: 'Reprendre',
  resumeDesc: '{0} session {1} — {2}/{3} questions',
  progressLabel: 'Progression',
  timerLabel: 'Temps restant',
  timeUp: 'Temps écoulé !',
  navHome: 'Accueil',
  navSettings: 'Conseils',

  speakingPageH1: 'Pratique TOEFL Speaking',
  speakingPageDesc: 'Travaillez toutes les tâches de Speaking avec enregistrement et retour IA.',
  writingPageH1: 'Pratique TOEFL Writing',
  writingPageDesc: 'Entraînez-vous au Build a Sentence, à l’Email et à l’Academic Discussion.',
  grammarBookTitle: 'Grammaire TOEFL',
  grammarCourseName: 'Grammaire anglaise pour le TOEFL',
  grammarBreadcrumb: 'Grammaire',

  statsTitle: 'Statistiques d’étude | Power TOEFL',
  statsDesc: 'Consultez vos progrès, vos points faibles et votre activité hebdomadaire.',
  statsH1: 'Mes statistiques',
  statsLoginPrompt: 'Connectez-vous pour voir vos statistiques personnelles.',
  statsLast7Days: '7 derniers jours',
  statsTotalWrong: 'Erreurs totales',

  leaderboardTitle: 'Classement d’étude',
  leaderboardWeekly: 'Hebdo',
  leaderboardMonthly: 'Mensuel',
  leaderboardLoading: 'Chargement...',
  leaderboardEmpty: 'Aucune donnée pour cette {period} pour le moment.',
  leaderboardEmptyWeek: 'période',
  leaderboardEmptyMonth: 'période mensuelle',
  leaderboardHint: 'Résolvez des tests pour apparaître automatiquement dans le classement.',
  leaderboardRank: 'Rang',
  leaderboardNickname: 'Pseudo',
  leaderboardSolved: 'Résolues',
  leaderboardAccuracy: 'Précision',
  leaderboardMe: 'Moi',

  pricingTitle: 'Tarifs Power TOEFL Pro — 12,99 €/mois | Free vs Premium | 2026',
  pricingDesc: 'Comparez l’offre gratuite et Pro : pratique illimitée, analyse IA, explications détaillées et une préparation TOEFL plus efficace.',
  pricingLoginRequired: 'Veuillez vous connecter pour continuer.',
  pricingPaymentError: 'Une erreur est survenue pendant le paiement.',
  pricingPaymentCancelled: 'Le paiement a été annulé.',
  pricingFaqQ1: 'Quelle est la différence entre Free et Pro ?',
  pricingFaqA1: 'Pro inclut des questions illimitées, des explications détaillées et une analyse IA.',
  pricingFaqQ2: 'Puis-je obtenir un remboursement ?',
  pricingFaqA2: 'En raison de la nature des produits numériques, les remboursements ne sont généralement pas disponibles. Toutefois, un remboursement peut être accordé à titre exceptionnel en cas d’exigence légale, de double facturation, de non-fourniture du service ou de panne technique majeure.',
  pricingFaqQ3: 'Comment annuler mon abonnement ?',
  pricingFaqA3: 'Vous pouvez gérer ou annuler votre abonnement depuis la plateforme de paiement.',
  pricingFaqQ4: 'Quelle différence entre l’offre annuelle et Lifetime ?',
  pricingFaqA4: 'L’offre annuelle est renouvelée chaque année ; Lifetime est un achat unique lorsqu’il est disponible.',

  aboutCtaHeading: 'Commencez maintenant',
  aboutCtaDesc: 'Lancez-vous avec un test TOEFL gratuit.',
  aboutCtaStart: 'Essayer gratuitement',
  aboutCtaPricing: 'Voir Premium',

  // --- Auto-translated UI strings ---
  lcTitle: "Compréhension orale",
  lcSubtitle: "Compréhension orale - 28 questions",
  lcTime: "36 min",
  rcTitle: "Lecture",
  rcSubtitle: "Lecture - 20 questions",
  rcTime: "35 min",
  startTest: "Commencer le test",
  fullTestStart: "Démarrer le test blanc complet (Lecture -> Compréhension orale)",
  fullTestDesc: "Terminer les deux sections séquentiellement",
  part1: "Lecture académique (20)",
  part2: "Conversations (10)",
  part3: "Conférences (18)",
  statQuestions: "Questions",
  statParts: "Parties",
  statMinutes: "Minutes",
  faqTitle: "Foire aux questions",
  faqDesc: "Trouvez des réponses sur le TOEFL et Power TOEFL.",
  faqPageTitle: "Inscription, score, validité du TOEFL - FAQ 2026 | Power TOEFL",
  faqPageDesc: "Inscription, conversion des scores, validité et stratégie par section sur une seule page.",
  faqMore: "Besoin de plus d'aide ? Nous mettons cette FAQ à jour régulièrement.",
  scoreChartPageTitle: "Conversion des scores TOEFL 2026 - Vérifiez instantanément les scores par section | Power TOEFL",
  scoreChartPageDesc: "Conversion des scores par section du TOEFL pour la lecture, l'écoute, l'expression orale et l'écriture. Entrez les bonnes réponses pour une estimation du score et un objectif.",
  scoreChartHeading: "Tableau de conversion des scores TOEFL",
  scoreChartIntro: "Les tableaux de 0–30 par section et du total 0–120 sont des estimations d’étude Power TOEFL sur l’ancienne échelle comparable. Les rapports officiels 2026 affichent d’abord les scores de section et global de 1–6 par demi-point.",
  scoreChartLC: "Conversion de lecture",
  scoreChartRC: "Conversion de l'écoute",
  scoreChartCorrect: "Correct",
  scoreChartConverted: "Score converti",
  scoreChartUnit: "",
  scoreChartPointUnit: "pts",
  scoreGuideTitle: "Guide des scores cibles",
  scoreGuide900: "Niveau supérieur",
  scoreGuide900Desc: "Ciblez 28+ par section. Fort pour les admissions les plus sélectives.",
  scoreGuide800: "Niveau élevé",
  scoreGuide800Desc: "Ciblez 22+ par section. Répond à la plupart des exigences d'admission.",
  scoreGuide700: "Intermédiaire-supérieur",
  scoreGuide700Desc: "Base académique atteinte. Admission conditionnelle possible.",
  scoreGuide600: "Intermédiaire",
  scoreGuide600Desc: "Concentrez-vous d'abord sur les fondamentaux de la lecture et de l'écoute.",
  scoreChartFaqTitle: "FAQ sur les scores TOEFL",
  scoreChartCtaTitle: "Vérifiez votre niveau maintenant",
  scoreChartCtaDesc: "Passez un test blanc TOEFL gratuit et estimez votre score.",
  scoreReadingHeader: "Lecture (0-30 pts)",
  scoreListeningHeader: "Compréhension orale (0-30 pts)",
  scoreSpeakingHeader: "Expression orale (0-30 pts)",
  scoreWritingHeader: "Expression écrite (0-30 pts)",
  scoreSpeakingDesc: "4 tâches sont notées sur une échelle de 0 à 4, puis converties en 30 points",
  scoreWritingDesc: "2 tâches sont notées sur une échelle de 0 à 5, puis converties en 30 points",
  vocabPageTitle: "600 mots TOEFL à haute fréquence - Significations et exemples | Power TOEFL",
  vocabPageDesc: "Apprenez 600 mots TOEFL par catégorie avec des significations et des exemples instantanés.",
  vocabHeading: "Vocabulaire essentiel du TOEFL",
  vocabIntro: "Étudiez le vocabulaire essentiel par catégorie. Cliquez pour révéler les significations.",
  vocabShowAll: "Tout montrer",
  vocabHideAll: "Tout cacher",
  vocabReset: "Réinitialiser",
  vocabClickToReveal: "Cliquez pour révéler la signification",
  vocabMotivation: "La répétition constante augmente votre score TOEFL.",
  vocabMyWords: "Mon vocabulaire",
  vocabAddWord: "Ajouter un mot",
  vocabAddWordPlaceholder: "Entrez un mot anglais",
  vocabMyWordsEmpty: "Aucun mot ajouté pour l'instant. Ajoutez votre premier mot ci-dessus.",
  vocabDeleteWord: "Supprimer",
  vocabLookingUp: "Recherche en cours...",
  vocabQuizTitle: "Quiz de Vocabulaire",
  vocabQuizDesc: "Testez les synonymes et antonymes des mots appris.",
  vocabQuizMode_synonym: "Quiz Synonymes",
  vocabQuizMode_antonym: "Quiz Antonymes",
  vocabQuizMode_mixed: "Quiz Mixte",
  vocabQuizClose: "Fermer",
  vocabQuizNoQuestions: "Pas encore assez d'éléments de quiz dans cette catégorie.",
  vocabQuizBack: "Retour",
  vocabQuizResult: "Résultat du Quiz",
  vocabQuizExcellent: "Excellent !",
  vocabQuizGood: "Bon travail. Encore un peu de pratique et vous serez prêt.",
  vocabQuizKeepGoing: "Continuez !",
  vocabQuizRetry: "Réessayer",
  vocabQuizFindSynonym: "Choisissez le synonyme du mot suivant",
  vocabQuizFindAntonym: "Choisissez l'antonyme du mot suivant",
  vocabQuizNext: "Suivant",
  vocabQuizFinish: "Voir le Résultat",
  vocabQuizStart: "Commencer le Quiz",
  vocabCatNaturalScience: "Sciences Naturelles",
  vocabCatSocialScience: "Sciences Sociales",
  vocabCatHumanities: "Sciences Humaines",
  vocabCatLifeScience: "Sciences de la Vie",
  vocabCatTechnology: "Technologie/Ingénierie",
  vocabCatAcademicGeneral: "Général Académique",
  tipsLCPageTitle: "Comment Améliorer Son Score d'Écoute au TOEFL | Routine d'Entraînement LC - Power TOEFL",
  tipsLCPageDesc: "Entraînement pratique à l'écoute du TOEFL pour des scores LC plus élevés : prise de notes pour les conversations et les cours magistraux, inférence et questions sur l'attitude de l'intervenant.",
  tipsLCHeading: "Stratégie de Score en Compréhension Orale du TOEFL",
  tipsLCIntro: "Stratégies essentielles et routines pratiques pour chaque partie de la section Compréhension orale du TOEFL.",
  tipsLCPractice: "Pratiquer la Compréhension Orale Maintenant",
  tipsLCPracticeDesc: "Appliquez la stratégie avec un test pratique réel.",
  tipsLCStartTest: "Commencer le Test de Compréhension Orale",
  tipsRCPageTitle: "Stratégie TOEFL Lecture - Guide de Passages Académiques | Power TOEFL",
  tipsRCPageDesc: "Stratégie de lecture académique pour le TOEFL : répartition du temps, inférence et approche par question-synthèse.",
  tipsRCHeading: "Stratégie de Lecture TOEFL",
  tipsRCIntro: "Un guide pratique pour la stratégie et le timing des passages de lecture du TOEFL.",
  tipsRCPractice: "Pratiquer la Lecture Maintenant",
  tipsRCPracticeDesc: "Appliquez la stratégie avec un test pratique réel.",
  tipsRCStartTest: "Commencer le Test de Lecture",
  tips7DayTitle: "Plan d'Étude de 7 Jours de Dernière Minute",
  tips7DayDesc: "Maximisez votre score avec une routine ciblée pour la dernière semaine",
  tipsTrapTitle: "Guide des Pièges Communs",
  tipsTrapDesc: "Apprenez les 5 schémas de piège les plus courants à l'avance",
  aboutPageTitle: "À Propos de Power TOEFL - Tests Blancs Gratuits et Outils d'Étude IA",
  aboutPageDesc: "Pratiquez le TOEFL avec des tests blancs complets, une analyse des faiblesses par IA et une révision automatique des mauvaises réponses. Découvrez ce que Power TOEFL offre.",
  aboutHeading: "Power TOEFL - Plateforme Pratique de Préparation au TOEFL",
  aboutS1Title: "Qu'est-ce que Power TOEFL ?",
  aboutS1Body: "Power TOEFL est une plateforme en ligne gratuite pour les apprenants qui se préparent au TOEFL. Nous proposons des tests blancs complets, des exercices générés par IA et des outils de révision des mauvaises réponses.",
  aboutS2Title: "À qui s'adresse-t-il ?",
  aboutS2Body: "Recommandé pour les étudiants préparant le TOEFL pour des admissions, les professionnels visant des scores requis, et les apprenants autonomes qui souhaitent une pratique structurée.",
  aboutS3Title: "Fonctionnalités Clés",
  aboutFeature1: "Tests blancs complets de style TOEFL avec plusieurs séries",
  aboutFeature2: "Pratique ciblée par section pour la Lecture, l'Écoute, la Conversation et l'Écriture",
  aboutFeature3: "Génération de questions et analyse des faiblesses assistées par l'IA",
  aboutFeature4: "Carnet de mauvaises réponses automatique avec révision espacée",
  aboutFeature5: "Tableau de conversion des scores et vocabulaire essentiel du TOEFL",
  aboutS4Title: "Gratuit vs Premium",
  aboutS4Body: "La version gratuite comprend les tests blancs, la pratique par section et la conversion des scores. La version Premium ajoute la génération illimitée par IA, l'étude sans publicité et l'accès complet aux tests blancs.",
  aboutS5Title: "Pourquoi les scores s'améliorent",
  aboutS5Body: "Grâce à la répétition espacée, à l'analyse ciblée des faiblesses et à des conditions de pratique réalistes, les apprenants peuvent construire une performance aux tests stable au fil du temps.",
  aboutS6Title: "Relations avec l'ETS",
  aboutS6Body: "Power TOEFL est une plateforme d'apprentissage indépendante et n'est pas affiliée ou approuvée par l'ETS. TOEFL est une marque déposée de l'ETS.",
  aboutS7Title: "Contact",
  aboutS7Body: "Pour toute demande de service, contactez skdaks0731@gmail.com.",
  catPageTitle: "Test Adaptatif TOEFL (CAT) - Difficulté automatique par IA | Power TOEFL",
  catPageDesc: "Test de pratique adaptatif par ordinateur du TOEFL. L'IA ajuste automatiquement la difficulté des questions en fonction de vos performances.",
  catHeading: "Test Adaptatif (CAT)",
  catIntro: "La difficulté s'ajuste automatiquement à votre précision. {count} questions par session.",
  catNote: "ℹ️ Remarque : Le vrai TOEFL iBT est un test linéaire (non adaptatif). Ce Practice CAT est un outil d'étude qui ajuste la difficulté à votre performance pour trouver rapidement votre niveau ; ce n'est pas une simulation du format réel de l'examen.",
  catSelectSection: "Sélectionner une section",
  catStartBtn: "Commencer le test adaptatif",
  catLoading: "Chargement de la prochaine question...",
  catNoMore: "Plus de questions disponibles",
  catComplete: "Test adaptatif terminé",
  catAccuracy: "Précision",
  catFinalLevel: "Niveau de difficulté final",
  catTryAgain: "Réessayer",
  catViewResults: "Voir les résultats",
  catNext: "Suivant",
  catExplanation: "Explication",
  catStop: "Arrêter",
  catPlayAudio: "Écouter l'audio",
  catReadingPassage: "Passage de lecture",
  pricingSaveBadge: "30% de réduction",
  pricingPerMonth: "mois",
  pricingSSL: "Paiement sécurisé",
  pricingCard: "Paiement par carte",
  pricingPaymentSuccess: "Premium activé avec succès !",
  pricingCurrentPlan: "Plan actuel",
  grammarSystematic: "Apprentissage systématique de la grammaire",
  grammarBookDesc: "Apprenez 20 sujets de grammaire essentiels au TOEFL avec des exemples pratiques et des exercices.",
  grammarTestAfter: "Testez-vous juste après l'étude !",
  grammarTestAfterDesc: "Vérifiez comment les points de grammaire apparaissent dans de vraies questions du TOEFL.",
  grammarMockTest: "Test blanc",
  grammarDoneTitle: "Étude de grammaire terminée ?",
  grammarDoneDesc: "Appliquez ce que vous avez appris lors d'un test blanc. Les mauvaises réponses sont automatiquement enregistrées pour révision.",
  grammarStartRC: "Commencer le test blanc de lecture",
  grammarPracticePart5: "Pratique de grammaire en lecture",
  leaderboardMyRank: "🏅 Mon classement : n°{rank}",
  speakingPageSub: "{count} + sujets d'expression orale gratuits — Listen and Repeat · Interview",
  speakingPageTitle: "Pratique d'expression orale TOEFL 2026 - {count} + sujets gratuits et exemples de réponses | Power TOEFL",
  speakingAllTasks: "Toutes",
  speakingNoPrompts: "Aucun sujet d'expression orale pour l'instant",
  speakingNoPromptsSub: "Les sujets sont en cours de génération. Veuillez vérifier bientôt.",
  speakingResponseTime: "Temps de réponse",
  writingPageSub: "{count} + tâches d'écriture gratuites — Build a Sentence · Email · Academic Discussion",
  writingPageTitle: "Pratique d'écriture TOEFL 2026 - {count} + tâches gratuites | Power TOEFL",
  writingAllTasks: "Toutes",
  writingNoPrompts: "Aucun sujet d'écriture pour l'instant",
  writingNoPromptsSub: "Les sujets sont en cours de génération. Veuillez vérifier bientôt.",
  testPrevious: "Précédent",
  testNext: "Suivant",
  testQuestion: "Question",
  testQuestionPrompt: "Lisez la question et choisissez la meilleure réponse.",
  testMarkAnswer: "Veuillez marquer le numéro de la meilleure réponse.",
  testSelect: "Sélectionner",
  testShowAnswer: "Afficher la réponse et l'explication",
  testCorrect: "Correct !",
  testIncorrect: "Incorrect.",
  testSubmit: "Soumettre le test",
  testContinue: "Continuer",
  resultsTitle: "Résultat du test {0}",
  resultsTimeUsed: "Temps utilisé : {0}m {1}s",
  resultsEstimatedScore: "Score estimé (sur 30)",
  resultsCorrect: "Correct",
  resultsIncorrect: "Incorrect",
  vocabSynonyms: "Synonymes",
  vocabAntonyms: "Antonymes",
  tipsLCButton: "Stratégie d'écoute",
  tipsRCButton: "Stratégie de lecture",
  practiceRelatedLinks: "📌 Contenu d'étudeTutoriels connexes",
  practiceOtherParts: "Autres parties",
  practiceMockTestCTA: "S'entraîner avec un test blanc complet",
  practiceTipsLink: "Voir les stratégies spécifiques à la partie",
  practiceGrammarLink: "Étudier la grammaire",
  practiceNotFound: "Partie introuvable.",
  practiceQuestionType: "Type de question",
  practiceTips: "💡 Conseils stratégiques",
  practiceExamples: "📝 Exemples de questions",
  practiceIntro: "📋 Aperçu de la partie",
  practiceCommonTypes: "📊 Types de questions courants",
  practiceStrategy: "🎯 Stratégies clés",
  practiceRecommendedFor: "👤 Recommandé pour",
  practiceFAQ: "❓ FAQ",
  practiceCTA: "S'entraîner maintenant",
  practiceCTADesc: "Vous pouvez vous entraîner à la partie {0} dans un environnement de test réaliste.",
  practiceStartTest: "Commencer le test blanc de la partie {0}",
  practiceQuestions: "Questions",
  practicePartSelect: "Sélectionner la partie",
  roundsTitle: "Tours de test blanc",
  roundLabel: "Test blanc TOEFL",
  roundUnit: "tour",
  comingSoon: "Bientôt disponible",
  testLoginPrompt: "Les notes de mauvaises réponses et les fonctions de reprise nécessitent une connexion.",
  testGoogleLogin: "Commencer avec Google en 3 secondes",
  roundSelect: "Sélectionner un autre tour",
  testAnswered: "Répondu",
  testSubmitTitle: "Soumettre le test {0}?",
  testSubmitDesc: "Vous avez répondu à {1} questions sur {0}.",
  testUnanswered: "{0} questions sans réponse.",
  testCannotUndo: "Cette action est irréversible.",
  testSubmitBtn: "Soumettre",
  resultsAccuracy: "Précision",
  resultsReview: "Vérifier les réponses",
  resultsYourAnswer: "Votre réponse : {0}",
  resultsCorrectAnswer: "Bonne réponse : {0}",
  resultsNoAnswer: "Pas de réponse",
  resultsHome: "Accueil",
  resultsWrongNotes: "Mauvaises réponses",
  resultsRetry: "Réessayer",
  resultsShare: "Partager les résultats",
  resultsShareText: "Mon score TOEFL estimé {0} est de {1}! ({2}/{3} corrects, {4}% de précision) Testez vos compétences gratuitement avec Power TOEFL!",
  resultsShareCopied: "Résultats copiés dans le presse-papiers!",
  resultsNoResults: "Pas de résultats de test.",
  resultsGoHome: "Rentrer à la maison",
  resultsSaved: "{0} mauvaises réponses enregistrées dans vos mauvaises réponses",
  wrongAnswersTitle: "Mauvaises réponses",
  wrongAnswersSaved: "Éléments enregistrés",
  wrongAnswersHome: "Accueil",
  wrongAnswersPracticeAll: "Tout pratiquer",
  wrongAnswersAll: "Toutes",
  wrongAnswersNoItems: "Pas encore de mauvaises réponses. Faites un test d'abord !",
  wrongAnswersYourAnswer: "Votre réponse : {0}",
  wrongAnswersCorrectIs: "Bonne réponse : {0}",
  wrongAnswersReviewed: "Révisé",
  wrongAnswersRemoved: "Retiré des mauvaises réponses",
  wrongAnswersPracticeMode: "Mode entraînement",
  wrongAnswersCorrectMsg: "Correct !",
  wrongAnswersIncorrectMsg: "Incorrect. Bonne réponse : {0}",
  wrongAnswersNextQuestion: "Question suivante",
  wrongAnswersFinish: "Terminer l'entraînement",
  wrongAnswersExitPractice: "Quitter l'entraînement",
  wrongAnswersPracticeComplete: "Entraînement terminé !",
  wrongAnswersNoPractice: "Pas de mauvaises réponses à entraîner",
  wrongAnswersLimitNotice: "Seules les 500 dernières mauvaises réponses sont affichées.",
  privacyPageTitle: "Politique de confidentialité — Power TOEFL",
  privacyPageDesc: "Politique de confidentialité de Power TOEFL.",
  privacyHeading: "Politique de confidentialité",
  privacyLastUpdated: "Dernière mise à jour : 29 mars 2026",
  privacyS1Title: "1. Informations personnelles collectées",
  privacyS1Body: "Power TOEFL collecte votre adresse e-mail, votre nom et votre photo de profil lorsque vous vous connectez avec Google pour fournir le service. Lorsque vous effectuez des paiements, les informations de paiement sont traitées via des fournisseurs de paiement (Dodo Payments/PayPal) ; nous ne stockons pas directement les détails des cartes de paiement.",
  privacyS2Title: "2. Finalité d'utilisation",
  privacyS2Body: "Les données personnelles collectées sont utilisées uniquement pour enregistrer les mauvaises réponses, suivre la progression des études, gérer les abonnements, le support client et améliorer le service.",
  privacyS3Title: "3. Conservation et suppression des données",
  privacyS3Body: "Lorsqu'un utilisateur supprime son compte, ses données personnelles sont supprimées immédiatement. Les enregistrements de paiement sont conservés jusqu'à 5 ans, conformément aux exigences fiscales, puis supprimés. Si d'autres lois exigent une conservation, les données seront conservées pendant la période requise, puis supprimées.",
  privacyS4Title: "4. Divulgation à des tiers",
  privacyS4Body: "Pour traiter les paiements, nous partageons le minimum d'informations requis (e-mail) avec Dodo Payments (commerçant enregistreur) ou PayPal. Nous ne fournissons pas les données personnelles des utilisateurs à d'autres tiers, sauf si la loi l'exige.",
  privacyS5Title: "5. Cookies et publicités",
  privacyS5Body: "Ce site diffuse des annonces via Google AdSense et utilise des cookies à cette fin. Les cookies peuvent être gérés dans les paramètres de votre navigateur. Pour plus de détails sur les cookies publicitaires de Google, consultez la politique de confidentialité de Google.",
  privacyS6Title: "6. Transferts internationaux de données",
  privacyS6Body: "Ce service utilise des serveurs situés à l'étranger et les données peuvent être transférées internationalement pour le traitement des paiements. Nous protégeons les données personnelles avec des mesures de sécurité appropriées.",
  privacyS7Title: "7. Droits des utilisateurs",
  privacyS7Body: "Les utilisateurs peuvent demander l'accès, la correction ou la suppression de leurs données personnelles à tout moment. Les résidents de l'UE/EEE ont des droits supplémentaires en vertu du RGPD. Pour supprimer votre compte, veuillez vous déconnecter et nous contacter.",
  privacyS8Title: "8. Contact",
  privacyS8Body: "Pour toute question relative à la confidentialité, veuillez contacter skdaks0731@gmail.com.",
  termsPageTitle: "Conditions d'utilisation — Power TOEFL",
  termsPageDesc: "Conditions d'utilisation de Power TOEFL.",
  termsHeading: "Conditions d'utilisation",
  termsLastUpdated: "Dernière mise à jour : 29 mars 2026",
  termsS1Title: "1. Présentation du service",
  termsS1Body: "Power TOEFL est une plateforme d'apprentissage en ligne pour la préparation au TOEFL, exploitée par ddookddak (notre nom commercial légal enregistré). Nous proposons des fonctionnalités gratuites et des abonnements premium payants (Pro/Lifetime) qui incluent des tests blancs, des pratiques spécifiques par partie, la génération de questions par IA et des notes de mauvaises réponses.",
  termsS2Title: "2. Éligibilité",
  termsS2Body: "Le service est disponible pour les utilisateurs âgés de 14 ans et plus. Certaines fonctionnalités (notes de mauvaises réponses, pratique IA, etc.) nécessitent une connexion avec un compte Google, et les fonctionnalités premium nécessitent un abonnement payant.",
  termsS3Title: "3. Propriété intellectuelle",
  termsS3Body: "Le contenu de ce site (questions, design, code, etc.) appartient à Power TOEFL. TOEFL est une marque déposée d'ETS ; ce site n'est pas affilié à ETS.",
  termsS4Title: "4. Services payants et paiements",
  termsS4Body: "Les abonnements premium sont traités via des services de paiement tiers (Dodo Payments/PayPal). Les frais d'abonnement sont facturés automatiquement ou en tant que paiement unique en fonction du plan sélectionné (mensuel/annuel/à vie). Les prix peuvent inclure la TVA ; le montant final est affiché au moment du paiement. Voir la politique de remboursement distincte pour les détails de remboursement.",
  termsS5Title: "5. Avertissement",
  termsS5Body: "Les scores des tests blancs et les supports d'étude fournis par ce service sont uniquement à titre de référence et ne garantissent pas les résultats réels du TOEFL. Nous ne sommes pas responsables des dommages directs ou indirects résultant de l'utilisation du service.",
  termsS6Title: "6. Conduite interdite",
  termsS6Body: "Vous ne pouvez pas copier ou distribuer des questions sans autorisation, surcharger le système, partager des comptes avec d'autres, ou vous engager dans d'autres activités illégales.",
  termsS7Title: "7. Modifications et suspension du service",
  termsS7Body: "L'opérateur peut modifier ou suspendre le service sans préavis et n'est pas tenu d'offrir une compensation.",
  termsS8Title: "8. Annulation d'abonnement",
  termsS8Body: "Les abonnements payants peuvent être annulés à tout moment. Après annulation, les fonctionnalités premium restent disponibles jusqu'à la fin de la période payée, après quoi le compte reviendra au plan gratuit.",
  termsS9Title: "9. Modifications des conditions",
  termsS9Body: "Ces conditions peuvent être mises à jour si nécessaire ; les changements seront publiés sur le site. L'utilisation continue du service après les changements constitue l'acceptation des conditions mises à jour.",
  refundPageTitle: "Politique de remboursement — Power TOEFL",
  refundPageDesc: "Politique de remboursement de l'abonnement premium Power TOEFL.",
  refundHeading: "Politique de remboursement",
  refundLastUpdated: "Dernière mise à jour: 15 avril 2026",
  refundS1Title: "1. Principe de remboursement",
  refundS1Body: "En raison de la nature des produits numériques, les remboursements ne sont généralement pas disponibles.",
  refundS2Title: "2. Cas exceptionnels de remboursement",
  refundS2Body: "Toutefois, un remboursement peut être accordé à titre exceptionnel en cas d’exigence légale, de double facturation, de non-fourniture du service ou de panne technique majeure.",
  refundS3Title: "3. Comment nous contacter",
  refundS3Body: "Pour les demandes liées au remboursement, veuillez utiliser le canal support/retours. Contact : skdaks0731@gmail.com",
  refundS4Title: "4. Résiliation de l’abonnement",
  refundS4Body: "Les abonnements payants peuvent être résiliés à tout moment. Après résiliation, l’accès premium reste actif jusqu’à la fin de la période de facturation en cours et aucun frais supplémentaire n’est facturé.",
  refundS5Title: "",
  refundS5Body: "",
  refundS6Title: "",
  refundS6Body: "",
  grammarChapter: "Chapitre",
  aiPracticeTitle: "Générez des questions illimitées du TOEFL AI — choisissez la partie et la difficulté pour des questions instantanées | Power TOEFL",
  aiPracticeDesc: "Sélectionnez une partie et une difficulté et l'IA générera instantanément des questions TOEFL. Questions d'entraînement gratuites avec explications automatiques — obtenez de nouvelles questions chaque jour.",
  aiPracticeH1: "✨ Générateur de questions TOEFL AI",
  aiPracticeSub: "L'IA génère des questions TOEFL en temps réel à la difficulté que vous avez choisie.",
  aiPartLabel: "Partie",
  aiDiffLabel: "Difficulté",
  aiBeginner: "Débutant (1.0–2.5)",
  aiIntermediate: "Intermédiaire (3.0–4.5)",
  aiAdvanced: "Avancé (5.0–6.0)",
  aiGenerate: "Générer des questions",
  aiGenerating: "Génération en cours...",
  aiRemainingToday: "{0} restants ce mois-ci",
  aiLimitReached: "Vous avez utilisé tous les crédits AI pour ce mois-ci",
  aiLimitUpgrade: "Achetez plus de crédits ou améliorez votre plan !",
  aiUpgrade: "Mettre à niveau",
  aiListenPrompt: "🔊 Pour les questions d'écoute, écoutez l'audio pendant que vous répondez",
  aiPlayAudio: "Écouter l'audio",
  aiStopAudio: "Arrêter",
  aiCorrect: "✅ Correct !",
  aiWrong: "❌ Incorrect.",
  aiCorrectAnswer: "Bonne réponse : {0}",
  aiPrev: "Précédent",
  aiNext: "Suivant",
  aiNewQuestions: "Nouvelles questions",
  aiEmptyTitle: "Générer des questions avec l'IA",
  aiEmptyDesc: "Sélectionnez une partie et une difficulté, puis appuyez sur « Générer des questions ».",
  aiLoadingMain: "L'IA génère et valide les questions...",
  aiLoadingSub: "Cela prend environ 10 à 20 secondes",
  statsTotalQuizzes: "Nombre total de quiz",
  statsTotalQuestions: "Nombre total de questions",
  statsAccuracy: "Précision",
  statsWrongSummary: "Résumé des mauvaises réponses",
  statsViewAll: "Voir les mauvaises réponses",
  statsReviewed: "Révisé",
  statsPending: "En attente de révision",
  statsTopicAccuracy: "Précision par sujet grammatical",
  statsAttempts: "{0} tentatives",
  statsEmpty: "Aucun enregistrement d'étude pour le moment. Essayez un quiz de grammaire !",
  statsStartGrammar: "Commencer l'étude de la grammaire",
  testLCTitle: "Test blanc gratuit de lecture TOEFL — lecture de passages académiques | 2026",
  testLCDesc: "Test blanc gratuit de lecture TOEFL mis à jour 2026. 20 questions basées sur des passages académiques. Les mauvaises réponses sont enregistrées automatiquement.",
  testRCTitle: "Test blanc gratuit d'écoute TOEFL — conversations et conférences | 2026",
  testRCDesc: "Test blanc gratuit d'écoute TOEFL mis à jour 2026. 28 questions tirées de conversations et de conférences. Explications IA et notes sur les mauvaises réponses fournies.",
  reviewTitle: "Révision du jour",
  reviewDesc: "Système de révision intelligent basé sur la courbe d'oubli d'Ebbinghaus",
  reviewSubtitle: "Révision aux moments optimaux selon la courbe d'oubli",
  reviewRemaining: "Révisions restantes",
  reviewProgress: "Progression des révisions",
  reviewCompleted: "🎉 Révision du jour terminée !",
  reviewCompletedDesc: "{0} questions révisées",
  reviewEmpty: "Aucun élément à réviser pour aujourd'hui",
  reviewEmptyDesc: "Soit vous avez terminé toutes les révisions, soit il n'y a pas encore de mauvaises réponses.",
  reviewStage: "Étape {0}",
  reviewNextInterval: "Intervalle de {0} jours",
  reviewCorrect: "Correct ! Passez à l'étape suivante.",
  reviewWrong: "Incorrect. Redémarrage à l'étape 1.",
  reviewNextReview: "Prochaine révision : dans {0} jours",
  reviewResetMsg: "Incorrect — vous réviserez à nouveau dans 1 jour.",
  reviewNext: "Question suivante",
  reviewFinish: "Terminer",
  reviewHowItWorks: "Méthode de révision Ebbinghaus",
  reviewDaysLater: "{0} jours plus tard",
  reviewExplanation: "Les éléments incorrects sont révisés à des intervalles de 1 → 3 → 7 → 14 → 30 → 60 jours. Les bonnes réponses passent à l'étape suivante ; les mauvaises réponses retournent à l'étape 1.",
  notifTitle: "Notifications",
  notifEmpty: "Aucune nouvelle notification",
  notifMarkAllRead: "Tout marquer comme lu",
  timeJustNow: "À l'instant",
  timeMinutes: "Il y a {0} minutes",
  timeHours: "Il y a {0} heures",
  timeDays: "Il y a {0} jours",
  scoreCardEstimated: "Score estimé",
  scoreCardCorrect: "Correct",
  scoreCardIncorrect: "Incorrect",
  scoreCardAccuracy: "Précision",
  pushTitle: "Recevoir des notifications d'étude",
  pushDesc: "Nous vous informons des temps de révision, des séries, et plus encore.",
  pushEnable: "Activer les notifications",
  navReview: "Révision",
  navStats: "Statistiques",
  navSubscription: "Abonnement",
  roundDetailHeading: "TOEFL Full Mock Test",
  roundDetailOtherRounds: "Voir les autres tours",
  roundSuffix: "tour",
  footer7DayPlan: "Plan d'étude de 7 jours",
  footerTrapPatterns: "Pièges récurrents",
  aiQuizTitle: "🤖 Questions pratiques personnalisées par IA",
  aiQuizDesc: "Questions de grammaire TOEFL générées par IA",
  aiQuizGenerateDesc: "L'IA génère 5 questions de grammaire de style TOEFL en temps réel.",
  aiQuizGenerate: "Générer des questions IA",
  aiQuizGenerating: "🤖 L'IA génère des questions...",
  aiQuizGeneratingTime: "Cela prend environ 5 à 10 secondes",
  aiQuizNew: "Nouvelles questions",
  aiQuizStats: "Statistiques cumulées :",
  aiQuizTimes: "fois",
  aiQuizCheckAnswers: "Vérifier les réponses",
  aiQuizPerfect: "🎉 Parfait !",
  aiQuizCorrectCount: "Correct",
  aiQuizSaving: "Enregistrement des résultats...",
  aiQuizTryNew: "Essayer de nouvelles questions",
  aiQuizError: "Échec de la génération des questions IA. Veuillez réessayer.",
  tipsDetailStrategy: "Stratégie détaillée",
  subLoginRequired: "Connexion requise.",
  grammarHome: "Accueil",
  grammarExamples: "Exemples de phrases",
  grammarTestKnowledge: "📝 Test de compétences",
  grammarTestKnowledgeDesc: "Répondez à de vraies questions liées à la grammaire que vous venez d'apprendre !",
  grammarCheckAnswers: "Vérifier les réponses",
  grammarPerfect: "🎉 Parfait !",
  grammarCorrectCount: "Correct",
  grammarMockCTA: "🔥 Vérifiez vos compétences avec un test blanc complet !",
  grammarMockCTADesc: "Test blanc complet de 100 questions RC + notes automatiques pour les mauvaises réponses",
  grammarStartRCMock: "Commencer le test blanc RC",
  grammarPractice5: "Pratique de lecture",
  grammarTestInPractice: "Vérifiez-le en pratique !",
  grammarTestInPracticeDesc: "Découvrez comment les points de grammaire apparaissent dans de vrais tests TOEFL.",
  grammarRelated: "📚 Grammaire associée",
  wrongAnswersGrammarAI: "Grammaire IA",
  streakDays: "jours",
  streakLabel: "Série d'étude",
  streak7: "Série de 7 jours !",
  streak14: "Série de 2 semaines !",
  streak30: "Incroyable ! Série de 30 jours !",
  reviewItems: "éléments",
  reviewTodayLabel: "Questions de révision du jour",
  reviewGoLabel: "📚 Commencer la révision →",
  loadingQuestions: "Chargement des questions...",
  tipsCoreTips: "Conseils essentiels",
  tipsStrategy: "Stratégie",
  tipsCTA: "Appliquez ces stratégies en pratique !",
  testScrollHint: "Faites défiler pour voir la question et les options",
  testPart1Label: "Lecture académique",
  testPart2Title: "Conversations",
  testPart2Desc: "Écoutez l'audio et choisissez la bonne réponse",
  testPart3Label: "Conférences",
  creditBuyBtn: "Acheter des crédits",
  creditBuyTitle: "Acheter des crédits IA",
  creditBuyDesc: "Achetez des crédits supplémentaires pour le feedback IA de l'expression orale/écrite et la pratique IA.",
  creditBuyError: "Échec de l'initialisation du paiement",
  creditBuyNote: "Paiement PayPal. Les crédits sont ajoutés immédiatement après que le paiement soit terminé.",
  creditUnit: "crédits",
  vocabFlashcardStart: 'Démarrer les flashcards',
  vocabFlashcardStop: 'Arrêter les flashcards',
  vocabFlashcardEmpty: 'Ajoutez des mots d\'abord pour démarrer les flashcards.',
  vocabFlashcardSpeed: 'Vitesse',
  vocabFlashcardSpeedSlow: 'Lente',
  vocabFlashcardSpeedNormal: 'Normale',
  vocabFlashcardSpeedFast: 'Rapide',
  vocabFlashcardShuffle: 'Mélanger',
  vocabFlashcardPrev: 'Précédent',
  vocabFlashcardNext: 'Suivant',
  vocabFlashcardFlip: 'Retourner',
  vocabFlashcardProgress: '{current} / {total}',
};

export default fr;
